import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';
import { hover, regular } from './common';
import { cssPropertyToDefaultValueMap } from '@wix/editor-elements-panel';

export const scrollButtonSkinParams: SkinDefinition = {
  // scroll button background regular
  'scroll-button-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: cssPropertyToDefaultValueMap.background,
    state: regular,
  },
  'scroll-button-hover-background': {
    type: 'BACKGROUND_FILL',
    state: hover,
  },
  // scroll button border regular
  'scroll-button-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-left'],
    state: regular,
  },
  'scroll-button-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-right'],
    state: regular,
  },
  'scroll-button-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-top'],
    state: regular,
  },
  'scroll-button-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-bottom'],
    state: regular,
  },
  // scroll button border hover
  'scroll-button-hover-border-left': {
    type: 'BORDER_SIDE',
    state: hover,
  },
  'scroll-button-hover-border-right': {
    type: 'BORDER_SIDE',
    state: hover,
  },
  'scroll-button-hover-border-top': {
    type: 'BORDER_SIDE',
    state: hover,
  },
  'scroll-button-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: hover,
  },
  // scroll button border radius regular
  'scroll-button-border-radius': {
    type: 'SIDES',
    defaultValue: cssPropertyToDefaultValueMap['border-radius'],
    state: regular,
  },
  // scroll button border radius hover
  'scroll-button-hover-border-radius': {
    type: 'SIDES',
    state: hover,
  },
  // scroll button box shadow
  'scroll-button-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: cssPropertyToDefaultValueMap['box-shadow'],
    state: regular,
  },
  'scroll-button-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: hover,
  },
  // scroll button icon regular
  'scroll-button-icon-display': {
    type: 'DISPLAY',
    defaultValue: 'unset',
    state: regular,
  },
  'scroll-button-icon-size': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap.height,
    state: regular,
  },
  'scroll-button-icon-color': {
    type: 'CSS_COLOR',
    defaultValue: cssPropertyToDefaultValueMap.color,
    state: regular,
  },
  'scroll-button-icon-rotation': {
    type: 'TRANSFORM',
    defaultValue: cssPropertyToDefaultValueMap.transform,
    state: regular,
  },
  // scroll button icon hover
  'scroll-button-hover-icon-display': {
    type: 'DISPLAY',
    state: hover,
  },
  'scroll-button-hover-icon-size': {
    type: 'SIZE',
    state: hover,
  },
  'scroll-button-hover-icon-color': {
    type: 'CSS_COLOR',
    state: hover,
  },
  'scroll-button-hover-icon-rotation': {
    type: 'TRANSFORM',
    state: hover,
  },
  // scroll button padding regular
  'scroll-button-padding-right': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['padding-right'],
    state: regular,
  },
  'scroll-button-padding-left': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['padding-left'],
    state: regular,
  },
  // scroll button padding hover
  'scroll-button-hover-padding-right': {
    type: 'SIZE',
    state: hover,
  },
  'scroll-button-hover-padding-left': {
    type: 'SIZE',
    state: hover,
  },
};
